import { AxiosInstance } from 'axios';

class AssetService {
  constructor(private ApiClient: AxiosInstance) {}

  getAssets = async (params: { assetClass: string }) => {
    const { data } = await this.ApiClient.get('/asset', { params });
    return data;
  };

  getObject = async (key: string) => {
    const { data } = await this.ApiClient.get(`/asset/object/${encodeURIComponent(key)}`);
    return data;
  };
}

export default AssetService;
